<template>
    <select
        :value="value"
        class="kgr-select"
        @change="update($event.target.value)"
    >
        <option
            value=""
            class="kgr-select__option"
        >
            {{ $t('pleaseChooseAnOption') }}
        </option>
        <option
            value="entryDate"
            class="kgr-select__option"
        >
            {{ $t('Gewünschtes Eintrittsdatum') }}
        </option>
        <option
            value="doneAtDate"
            class="kgr-select__option"
        >
            {{ $t('Bewerbungsdatum') }}
        </option>
        <option
            v-show="showAcceptedDate"
            value="acceptedDate"
            class="kgr-select__option"
        >
            {{ $t('Übernommen am') }}
        </option>
        <option
            v-show="showRejectedDate"
            value="rejectedDate"
            class="kgr-select__option"
        >
            {{ $t('Abgelehnt am') }}
        </option>
        <option
            value="lastname"
            class="kgr-select__option"
        >
            {{ $t('Nachname Bewerber') }}
        </option>
        <option
            value="firstname"
            class="kgr-select__option"
        >
            {{ $t('Vorname Bewerber') }}
        </option>
    </select>
</template>

<script>
export default {
    props: {
        tab: {
            type: String,
            required: true,
        },
        showAcceptedDate: {
            type: Boolean,
            required: true,
        },
        showRejectedDate: {
            type: Boolean,
            required: true,
        },
        value: {
            type: String,
            required: false,
        },
    },
    watch: {
        tab: {
            immediate: true,
            handler(newTab) {
                let value = localStorage.getItem(`kgr:member-application-sort-select:${newTab}`);
                if (value === 'createDate') {
                    value = 'doneAtDate';
                }
                if (value === null) {
                    // No persisted sort yet: fall back to the current (default) sort so the dropdown matches
                    // the order the list is loaded with.
                    value = this.value ?? null;
                }

                this.update(value);
            },
        },
    },
    methods: {
        update(value) {
            const inputValue = value === '' ? null : value;
            this.$emit('input', inputValue);
            this.$nextTick(() => {
                this.$emit('post-input', inputValue);
            });

            if (!inputValue) {
                localStorage.removeItem(`kgr:member-application-sort-select:${this.tab}`);
                return;
            }
            localStorage.setItem(`kgr:member-application-sort-select:${this.tab}`, inputValue);
        },
    },
};
</script>
